export default __webpack_public_path__ + "media/images/front/municipality_collaboration/toba/ogp-015138695b2687123b061d02b6570081.png";